import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs';
import { BaseResizableComponent } from '@src/app/modules/base';
import { fixRouteParam } from '@src/utils';

import { LpCollectionStatisticsService, LpCollectionStatisticsStoreService } from './services';
import { CollectionStatistics } from './types';

@Component({
  selector: 'lp-collection-statistics',
  templateUrl: './lp-collection-statistics.component.html',
  styleUrls: ['./lp-collection-statistics.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpCollectionStatisticsComponent extends BaseResizableComponent {
  private readonly statisticsService = inject(LpCollectionStatisticsService);
  private readonly route = inject(ActivatedRoute);
  private readonly lpCollectionStatisticsStore = inject(LpCollectionStatisticsStoreService);

  statistics?: CollectionStatistics;
  collectionId?: string;
  loading = true;

  override ngOnInit(): void {
    super.ngOnInit();

    this.route.paramMap.pipe(takeUntil(this.destroyed$$)).subscribe(async params => {
      this.collectionId = fixRouteParam(params.get('collectionId'));

      this.route.queryParamMap.pipe(takeUntil(this.destroyed$$)).subscribe(async queryParams => {
        const unionId = fixRouteParam(queryParams.get('unionId'));

        if (this.collectionId) {
          this.statisticsService
            .getStatistics(this.collectionId, unionId)
            .pipe(takeUntil(this.destroyed$$))
            .subscribe();
        }
      });

      this.lpCollectionStatisticsStore.data$.pipe(takeUntil(this.destroyed$$)).subscribe(() => {
        if (!this.collectionId) return;

        this.statistics = this.lpCollectionStatisticsStore.getData(this.collectionId);
        this.loading = !this.statistics;
        this.cdr.markForCheck();
      });
    });
  }
}
